import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataCacheService } from "@app/services/caching/data-cache.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { CameraApplicationState, CameraAppType, ICameraApp } from "../_models/ICameraApp";

@Injectable({
    providedIn: 'root'
})
export class CameraAppService {

    private cameraApplicationsCacheName: string = "cameraAppCache";

    constructor(
        private readonly http: HttpClient,
        private readonly dataCacheService: DataCacheService
    ) { }

    getApplicationFiles(invalidateCache = false): Observable<ICameraApp[]> {
        return this.dataCacheService.getOrRequest(this.cameraApplicationsCacheName, () => this.getApplicationFilesFromDb(), { invalidateCache });
    }

    getApplicationFilesFromDb(): Observable<ICameraApp[]> {
        return this.http.get<ICameraApp[]>(`/api/cameras/commserver/applications`);
    }

    updateApp(app: ICameraApp): Observable<ICameraApp> {
        return this.http.post<ICameraApp>(`/api/cameras/commserver/applications/update`, app);
    }

    saveApp(formData: FormData): Observable<ICameraApp> {
        return this.http.post<ICameraApp>(`/api/cameras/commserver/applications`, formData, {
            headers: new HttpHeaders({
                'enctype': 'multipart/form-data'
            })
        }).pipe(
            tap(app => {
                this.dataCacheService.addOrUpdateItem(app, this.cameraApplicationsCacheName)
            })
        )
    }

    downloadFile(guid: string): Observable<any> {
        return this.http.get(`/commserver/api/assets/app/${guid}`, { responseType: 'blob' });
    }

    createNewApp(): ICameraApp {
        return {
            Id: "",
            CameraAppType: CameraAppType.Updater,
            Name: "",
            Description: "",
            State: CameraApplicationState.Beta,
            Version: "",
            IsActive: true
        }
    }

    getAppType(appId: string, cameraApplications: ICameraApp[]): CameraAppType {
        return cameraApplications.find(a => a.Id == appId).CameraAppType;
    }
}
